import React from "react";
import { Helmet } from 'react-helmet';
import { useMyContext } from "../../components/Provider/CommonProvider";

function Metadata() {
    const { siteMetadata } = useMyContext();
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/');
    const lastSegment = segments.filter(segment => segment !== '').pop() || '';

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta property="og:url" content={lastSegment} />
                <meta property="og:title" content={siteMetadata?.website_name} />
                <meta property="og:description" content={siteMetadata?.website_description} />
                <meta property="og:image" content={siteMetadata?.logo_url} />
                <title>{siteMetadata?.website_name}</title>
                <link rel="icon" type="image/x-icon" href={siteMetadata?.favicon_url}></link>
                <link rel="canonical" href={lastSegment} />
            </Helmet>
        </>
    );
}

export default Metadata;
